export default "__VITE_ASSET__03664170__"